import React from 'react'
import { Redirect } from 'wouter';

export const NewEditorList = () => {
  return (<Redirect to="/editor" />)
};
